'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import createReactClass from 'create-react-class';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import H5 from 'UIComponents/elements/headings/H5';
export default createReactClass({
  displayName: "SkeletonDurationPicker",
  render: function render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "duration-picker width-100",
      children: [/*#__PURE__*/_jsx(H5, {
        className: "skeleton-text",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "prebook.durationPicker.header"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "skeleton m-top-8 m-bottom-12"
      })]
    });
  }
});